import IMask from 'imask';
import 'intl-tel-input/build/css/intlTelInput.min.css';
import IntlTelInput from '../../../base/script/intl';
import AnimationHeight from '../../animation/height/animation-height';
import inputTempl from './input-country.pug';

export default {
  template: inputTempl(),
  props: {
    showError: Boolean,
    errorText: {
      type: String,
      default: 'Пожалуйста, заполните поле',
    },
  },
  delimiters: ['${', '}}'],
  components: {
    AnimationHeight,
  },
  data() {
    return {
      currentCode: '+7',
      currentCodeMask: '+7',
      input: null,
      inputMask: null,
    };
  },
  methods: {
    setInputPadding(code) {
      // eslint-disable-next-line
      this.input.style.paddingLeft = `${code.length === 4 ? 116 : code.length === 3 ? 108 : code.length === 2 ? 100 : 88}px`;
    },
  },
  mounted() {
    const button = this.$el.querySelector('.input-country__select-btn');
    this.input = this.$el.querySelector('.input__field input');

    this.input.removeAttribute('placeholder');
    this.iTI = new IntlTelInput(this.input, {
      initialCountry: (window.inputPhoneCountries && window.inputPhoneCountries.defaultCountry) ? window.inputPhoneCountries.defaultCountry : 'RU',
      preferredCountries: (window.inputPhoneCountries && window.inputPhoneCountries.preferredCountries) ? window.inputPhoneCountries.preferredCountries : ['ru', 'by', 'ae', 'tr', 'kz'],
      dropdownContainer: document.body.classList.contains('iti-mobile') ? this.$el.querySelector('.input__field') : null,
      separateDialCode: true,
      customPlaceholder: (selectedCountryPlaceholder, selectedCountryData) => {
        if (selectedCountryData.iso2 === 'fi' || selectedCountryData.iso2 === 'nz' || selectedCountryData.iso2 === 'bg' || selectedCountryData.iso2 === 'jp' || selectedCountryData.iso2 === 'my') {
          return `${selectedCountryPlaceholder}7`;
        }
        if (selectedCountryData.iso2 === 'mm') {
          return `${selectedCountryPlaceholder}78`;
        }
        if (selectedCountryData.iso2 === 'id') {
          const placeholder = selectedCountryPlaceholder.slice(1, -1);
          return `${placeholder}`;
        }
        if (selectedCountryData.iso2 === 'br' || selectedCountryData.iso2 === 'ee') {
          const placeholder = selectedCountryPlaceholder.slice(0, -1);
          return `${placeholder}`;
        }
        return `${selectedCountryPlaceholder}`;
      },
    });
    this.input.setAttribute('data-phone-prefix', `+${this.iTI.selectedCountryData.dialCode}`);
    this.input.setAttribute('placeholder', '000 000-00-00');
    this.setInputPadding(this.iTI.selectedCountryData.dialCode);
    this.im = new IMask(this.input, {
      mask: this.input.getAttribute('placeholder').replace(/[0-9]/g, 0),
    });
    this.im.updateValue();
    this.input.im = this.im;
    this.input.addEventListener('countrychange', () => {
      const code = this.iTI.selectedCountryData.dialCode;
      this.input.setAttribute('data-phone-prefix', `+${code}`);
      if (this.im) {
        this.input.value = '';
        this.im.destroy();
        const regex = /[0-9]/g;
        if (this.input.getAttribute('placeholder')) {
          const mask = this.input.getAttribute('placeholder').replace(regex, 0);
          this.im = new IMask(this.input, {
            mask: `${mask}`,
          });
          this.im.updateValue();
          this.input.im = this.im;
        }
      }
      this.setInputPadding(code);
    });
    this.input.addEventListener('input', () => {
      if (this.input.value.length === this.input.placeholder.length) {
        this.$emit('input-complete', this.input.value);
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target === button) {
        e.preventDefault();
        this.openSelect = this.openSelect !== true;
      } else this.openSelect = false;
    });

    if (this.input.im) {
      window.addEventListener('intlTelUtilsLoad', () => {
        this.input.im.mask = this.input.getAttribute('placeholder').replace(/[0-9]/g, 0);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./core/input/country/input-country.js